var map = {
	"./1.PNG": 21470,
	"./2.PNG": 6586,
	"./3.PNG": 59971,
	"./4.PNG": 37036,
	"./animatedStories.png": 52547,
	"./landingimage.PNG": 53478,
	"./mainimage.PNG": 20806,
	"./selectLevel.png": 33691,
	"./ss1.png": 55586,
	"./ss2.png": 11673,
	"./ss3.png": 5424
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29129;